import '@fontsource/montserrat/100.css';
import '@fontsource/montserrat/200.css';
import '@fontsource/montserrat/300.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
import '@fontsource/montserrat/800.css';
import '@fontsource/montserrat/900.css';
import '@fontsource/merriweather/300.css';
import '@fontsource/merriweather/400.css';
import '@fontsource/merriweather/700.css';
import '@fontsource/merriweather/900.css';
import '@fontsource/roboto-mono/300.css';

import './design-system/styles/globals.css';
import '../scss/main.scss';

import { QueryClient, QueryClientProvider } from 'react-query';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Provider } from 'react-redux';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter as Router } from 'react-router-dom';
import { createRoot } from 'react-dom/client';

import { App, ScrollToTop } from './containers';
import { MixpanelProvider } from 'react-mixpanel';
import ToasterPortal from 'containers/ToasterPortal';
import { configuredStore } from 'utils/app';
import { theme } from 'utils/theme';

const globalScope = typeof globalThis !== 'undefined' ? globalThis : window;

(async () => {
    // Load polyfills
    if ('ResizeObserver' in window === false) {
        const module = await import('@juggle/resize-observer');
        window.ResizeObserver = module.ResizeObserver;
    }
})();

const queryClient = new QueryClient();

createRoot(document.getElementById('app')).render(
    <MixpanelProvider mixpanel={globalScope.mixpanel}>
        <Provider store={configuredStore}>
            <QueryClientProvider client={queryClient}>
                <DndProvider backend={HTML5Backend}>
                    <Router>
                        <ScrollToTop />
                        <App theme={theme} />
                    </Router>
                    <ToasterPortal />
                    <ReactQueryDevtools initialIsOpen={false} />
                </DndProvider>
            </QueryClientProvider>
        </Provider>
    </MixpanelProvider>,
);
